<style lang="scss" scoped>
.left-menu {
    border-right: 1px solid rgb(240,242,245);
    width: 40% !important;
}
.right-menu {
    margin-left: 10px;
    width: 60%;
    display: flex;
    // align-items: center;
    background: rgb(240,242,245);
}
.right-content {
    padding: 5px 15px;
    // background: rgb(240,242,245);
}
.ivu-menu-item-active {
    color: white !important;
    background: #2d8cf0 !important;
}
</style>
<template>
    <div class="clearfix padding-right-20">
        <!-- <Form ref="formdata" :model="formData" :labelWidth="120">
            <FormItem :label="$t('erp.b2c.delivery_method', { defaultValue: '出库方式' })" :rules="required" prop="outboundMode">
                <Select v-model="formData.outboundMode" clearable>
                    <Option :value="0">{{$t('erp.b2c.direct_issue',{defaultValue: '直接出库'})}}</Option>
                    <Option :value="1">{{$t('erp.b2c.goods_collection',{defaultValue: '集货出库-不上报打托信息'})}}</Option>
                    <Option :value="2">{{$t('erp.b2c.goods_collection_underpinning',{defaultValue: '集货出库-上报打托信息'})}}</Option>
                </Select>
            </FormItem>
        </Form>
        <div style="margin: 0 0 20px 120px; ">
            <div v-if="formData.outboundMode == 0" style="background: #f0f2f5; padding: 5px 15px; word-wrap: normal;">{{$t('erp.b2c.direct_issue_describtion',{defaultValue: '直接出库描述'})}}</div>
            <div v-if="formData.outboundMode == 1" style="background: #f0f2f5; padding: 5px 15px; word-wrap: normal;">{{$t('erp.b2c.goods_collection_describtion',{defaultValue: '集货出库-不上报打托信息描述'})}}</div>
            <div v-if="formData.outboundMode == 2" style="background: #f0f2f5; padding: 5px 15px; word-wrap: normal;">{{$t('erp.b2c.goods_collection_underpinning_describtion',{defaultValue: '集货出库-上报打托信息描述'})}}</div>
        </div> -->
        <div style="display:flex; margin-bottom: 20px">
            <Menu class="left-menu" :active-name=formData.outboundMode @on-select="select">
                <MenuItem name="0" style="text-align:center">{{$t('erp.b2c.direct_issue',{defaultValue: '直接出库'})}}</MenuItem>
                <MenuItem name="1" style="text-align:center">{{$t('erp.b2c.goods_collection',{defaultValue: '集货出库-不上报打托信息'})}}</MenuItem>
                <MenuItem name="2" style="text-align:center">{{$t('erp.b2c.goods_collection_underpinning',{defaultValue: '集货出库-上报打托信息'})}}</MenuItem>
            </Menu>
            <div class="right-menu">
                <div v-if="formData.outboundMode == '0'" class="right-content" v-html="$t('erp.b2c.direct_issue_describtion',{defaultValue: '直接出库描述'})"></div>
                <div v-if="formData.outboundMode == '1'" class="right-content" v-html="$t('erp.b2c.goods_collection_describtion',{defaultValue: '集货出库-不上报打托信息描述'})"></div>
                <div v-if="formData.outboundMode == '2'" class="right-content" v-html="$t('erp.b2c.goods_collection_underpinning_describtion',{defaultValue: '集货出库-上报打托信息描述'})"></div>
            </div>
        </div>
        <div class="pull-right button-container">
            <Button class="margin-right-15" type="primary" @click="submit">{{$t('erp.distribution.confirm_submit', { defaultValue: '提交' })}}</Button>
            <Button type="default" @click="cancel">{{$t('global.common.operation_cancel', { defaultValue: '取消' })}}</Button>
        </div>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>
<script>
import { HttpSwitchIssueMethod } from "@/service/boss/distribution";
export default {
    props: ['activeids'],
    data () {
        return {
            formData: {
                outboundMode: '0',
            },
            required: [{
                required: true,
                message: this.$t("global.common.fill_requiredd", { defaultValue: '该信息不能为空,请填写' })
            }],
            loading: false,
        }
    },
    computed: {

    },
    methods: {
        select(name){
            this.formData.outboundMode = name
        },
        async submit () {
            // let bool = await this.$refs['formdata'].validate();
            // if (!bool) return;
            this.loading = true;
            await HttpSwitchIssueMethod({
                deliverOrderIds: this.activeids,
                outboundMode: this.formData.outboundMode,
            }).then(res => {
                this.$Message.success({
                    content: res.message,
                    duration: 30,
                    closable: true
                });
                this.$emit('on-update');
                this.cancel();
            }, err => {
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            }).finally(() => {
                this.loading = false;
            });
        },
        cancel () {
            this.$emit('on-close');
        }
    }
}
</script>
